module.exports = {"TXTCLI_Show_Balance":{"id":"TXTCLI_Show_Balance","defaultMessage":"Kontostand anzeigen"}}